/**
 * XUẤT CSV — và hai cái bẫy Excel mà một tệp danh tính thiết bị không được dính (YC-24 mục G).
 */
import { boDau } from './khongdau';

/**
 * 🔴 BẪY 1 — EXCEL ĂN MẤT DỮ LIỆU DANH TÍNH.
 *
 * `GW-3c:84:00:00`, `00:1A:2B` hay một MAC toàn chữ số: Excel sẽ **cắt số 0 đầu**, đổi sang
 * **số khoa học**, hoặc hiểu thành ngày tháng. Và cột nó phá lại đúng là cột **danh tính duy
 * nhất không tái tạo được** — mất là mất hẳn, không suy lại từ đâu được.
 *
 * `="..."` buộc Excel đọc là VĂN BẢN. Xấu khi mở bằng trình xem CSV thô, nhưng tệp này sinh
 * ra để mở bằng Excel; ưu tiên đúng chỗ nó sẽ được mở.
 */
export function oVanBan(v: string): string {
  return `="${String(v).replace(/"/g, '""')}"`;
}

/**
 * 🔴 BẪY 2 — CHÈN CÔNG THỨC.
 *
 * Một ô bắt đầu bằng `= + - @` bị Excel đọc là **công thức**. Tên tủ do người gõ, nên
 * `=1+1` hay `-Tủ số 3` là chuyện có thể xảy ra — và một ô công thức trong tệp bàn giao thì
 * người nhận thấy `#NAME?` chứ không thấy cái tên.
 *
 * ⚠ Cố ý KHÔNG áp cho `oVanBan()`: ở đó dấu `=` là của CHÍNH TA, đặt vào có chủ đích.
 */
export function oAnToan(v: unknown): string {
  const s = v == null ? '' : String(v);
  const canDe = /^[=+\-@\t\r]/.test(s) ? `'${s}` : s;
  return `"${canDe.replace(/"/g, '""')}"`;
}

/**
 * Ghép một tệp CSV. BOM ở đầu để Excel đọc đúng tiếng Việt — thiếu nó thì "Tủ số 3" thành
 * "Tá»§ sá»‘ 3", và người nhận sẽ nghĩ dữ liệu hỏng chứ không nghĩ tệp hỏng.
 */
export function ghepCsv(tieuDe: string[], hang: string[][]): string {
  return '﻿' + [tieuDe.map(oAnToan).join(','), ...hang.map((h) => h.join(','))].join('\r\n') + '\r\n';
}

/**
 * ⚠ TÊN TỆP PHẢI NÓI RA BỘ LỌC (YC-24 mục G).
 *
 * Người mở tệp ba tuần sau **không có cách nào** biết nó là cả kho hay một phần — trừ khi ta
 * nói ra. Một tệp `danh-sach-cho.csv` không có ngày và không có bộ lọc là một tệp không dùng
 * để đối chiếu được với bất cứ thứ gì.
 */
export function tenTepCsv(goc: string, moTaLoc: string, luc = new Date()): string {
  const hai = (n: number) => String(n).padStart(2, '0');
  const dau = `${luc.getFullYear()}${hai(luc.getMonth() + 1)}${hai(luc.getDate())}-${hai(luc.getHours())}${hai(luc.getMinutes())}`;
  /* ⚠ Lõi bỏ dấu nay ở `lib/khongdau.ts` — MỘT chỗ, dùng chung với ô tìm tuyến. Phần còn lại
     (nén thành `-`, bỏ ký tự lạ) là việc RIÊNG của tên tệp, nên nó ở lại đây. */
  const sach = boDau(moTaLoc)
    .replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-|-$/g, '').toLowerCase();
  return `${goc}_${sach || 'tat-ca'}_${dau}.csv`;
}

/** Đẩy chuỗi ra thành một tệp tải về. */
export function taiVe(tenTep: string, noiDung: string) {
  const url = URL.createObjectURL(new Blob([noiDung], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url; a.download = tenTep;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}
